
//退出登录
exports.logout=()=> {
    //this.$message.success('退出成功');
    window.sessionStorage.clear();
    //this.$router.push("/login");
    return true;
}


// WEBPACK FOOTER //
// ./src/utils/utils/auth.js